import { createResource } from "~/lib/resourceFactory";
import { getWorksheets, listWorksheets } from "./worksheets.api";

type WorksheetsPage = Awaited<ReturnType<typeof listWorksheets>>;
type WorksheetsDetail = Awaited<ReturnType<typeof getWorksheets>>;

export type WorksheetsParams = {
  businessId: string;
  search?: string;
  offset?: number;
  limit: number;
  ids?: string[];
};

export type WorksheetsDetailParams = {
  businessId: string;
  id: string;
};

export const WorksheetsResource = createResource<
  WorksheetsPage,
  WorksheetsParams
>({
  key: (p) =>
    [
      "worksheet",
      p.businessId,
      p.limit,
      p.search ?? "",
      p.offset ?? 0,
      p.ids === undefined ? "*" : p.ids.join(","),
    ] as const,
  fetcher: (p) =>
    listWorksheets({
      data: {
        businessId: p.businessId,
        search: p.search,
        offset: p.offset,
        limit: p.limit,
        ids: p.ids,
      },
    }),
});

export const WorksheetDetailResource = createResource<
  WorksheetsDetail,
  WorksheetsDetailParams
>({
  key: ({ businessId, id }) => ["worksheet", businessId, id] as const,
  fetcher: ({ businessId, id }) => getWorksheets({ data: { businessId, id } }),
});
